import React from "react";
import { useTranslation } from "react-i18next";
import cogsolAvatar from "../assets/cogsol-logo.svg";

const DEFAULT_AVATAR = cogsolAvatar;

/**
 * Bubble shown when the chat status is WAITING_FOR_OAUTH.
 * Displays the assistant's message plus a re-authorize button.
 */
const WaitingOAuthBubble = ({
  message,
  serverId,
  chatId,
  onReauthorize,
  assistantColors,
  urlLogo,
  chatName,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-0.5 my-6">
      <div className="flex items-center gap-1.5 mb-1">
        <img
          src={urlLogo || DEFAULT_AVATAR}
          alt={chatName || t("assistant")}
          className="w-8 h-8 rounded-md object-cover shrink-0"
          onError={(e) => { e.target.src = DEFAULT_AVATAR; }}
        />
        <span
          className="text-xs font-semibold text-gray-500 truncate max-w-[200px]"
          style={{ color: assistantColors?.nameColor || undefined }}
        >
          {chatName || t("assistant")}
        </span>
      </div>
      <p className="text-[15px] leading-relaxed mb-2">{message.content}</p>
      <button
        type="button"
        className="px-4 py-1.5 text-sm text-white rounded-lg transition-colors hover:opacity-90 w-fit cursor-pointer"
        style={{
          backgroundColor: assistantColors?.primaryColor || "black",
        }}
        onClick={() => onReauthorize(serverId, chatId)}
      >
        {t("mcpOAuth.reAuthorize")}
      </button>
    </div>
  );
};

export default WaitingOAuthBubble;
